export enum Direction {
    Previous = 1,
    Next = 2,
}